import React, { useState, useEffect } from "react";
import Loader from "./Loader";

const IClasses = {
    content: '',
    header: '',
    body: '',
    footer: ''
}

export default function Modal({
	show,
	toggle,
	blank,
	callback,
	children,
	title,
	acceptText,
	size = "sm",
	showCancelBtn = true,
	footer,
    classes = IClasses,
	closeWithEsc = true,
    saving = false
}) {
	const [mostrar, setMostrar] = useState(false);

    const callbackWrapper = async () => {
        await callback ? callback() : toggle();
    }

	const modalSize = () => {
		if (size === "sm" || !size) return null;

		if (size === "lg") {
			return "80%";
		} else if (size === "md") {
			return "60%";
		}

		return size;
	};

	useEffect(() => {
		setMostrar(show);
	}, [show]);

	// `mostrar` lo sincroniza un efecto, así que va un commit por detrás de
	// `show`: al cerrar, el modal alcanza a renderizarse una vez más con los
	// datos que la pantalla ya limpió en el mismo evento —y el hijo revienta al
	// leerlos—. Con React 19 eso pasa siempre, porque agrupa los setState de una
	// función async. `mostrar` sigue mandando para cerrar con Escape.
	const visible = Boolean(show && mostrar);

	// Escape tiene que cerrar el modal a través de `toggle`, igual que el botón
	// Cancelar. Si solo apaga `mostrar`, el `show` del padre se queda en true y
	// al volver a abrir no cambia nada: el efecto de arriba no corre y el modal
	// no reaparece. El listener vive solo mientras el modal está visible.
	useEffect(() => {
		if (!visible || !closeWithEsc) return;

		const onKeyUp = (e) => {
			if (e.key !== "Escape") return;
			setMostrar(false);
			if (toggle) toggle();
		};

		window.addEventListener("keyup", onKeyUp);
		return () => window.removeEventListener("keyup", onKeyUp);
	}, [visible, closeWithEsc, toggle]);

	if (blank) {
		return (
			visible && (
				<div className={`popup ${visible ? "active" : ""}`}>
					<div
						className={`popup__content ${classes.content}`}
						style={{ maxWidth: modalSize(), borderRadius: '5px' }}
					>
						{children}
					</div>
					<div className="popup__overlay"></div>
				</div>
			)
		);
	}

	return (
		visible && (
			<div className={`popup ${visible ? "active" : ""}`}>
				<div
					className={`popup__content ${classes.content}`}
					style={{ maxWidth: modalSize() }}
				>
					<div className={`popup__header ${classes.header}`}>{title}</div>
					<div className={`popup__body ${classes.body}`}>{children}</div>
					<div className={`popup__footer ${classes.footer}`}>
						{footer ? (
							<>{footer}</>
						) : (
							<>
								{showCancelBtn && (
									<button
										type="button"
										onClick={() => {
											setMostrar(false);
											toggle();
										}}
										className="btn btn-plain"
									>
										Cancelar
									</button>
								)}
                                {saving ? <Loader type="small" /> : (
                                    <button
                                        type="button"
                                        onClick={callbackWrapper}
                                        className="btn btn-primary"
                                    >
                                        {acceptText || "Aceptar"}
                                    </button>
                                )}
							</>
						)}
					</div>
				</div>
				<div className="popup__overlay"></div>
			</div>
		)
	);
}
